module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAOlJREFUOE/Nk80NgkAQhd/4c9ZOJIGDcHGpwFiCJdiBdmAJ2oEdOCfhgGTtwBLwpIm6YzD+QYAoJ/e4yft233szZLsqIUIHNY4I9uR4SmpoXxKyXTUnwKoDEUBTHeGnphLg9JVCA4NPwcVg2SRY24BX6X01wFUMygJg4KOBtTEYxyEvyPKU1RbKtHA+yk5rTpwKQPp6CilswQgmccDzIoAIRkTv0H8HAAkJ9DOXu4WWQTcT1Am61EKutt9D/D/AY5R7z58JkFwFEx3yvrDGvIWSZZpFG55+BShcZwM/CpltT60IGJbtiwgON1yZatO8ZmAOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/ic_danhmucbaitap.png
// module id = 1265
// module chunks = 0